import { getRequest } from '../../../api/api';

export function getPortfolioData(callbackResponse) {
    return getRequest(
        'api/v1/wallet/net-fund',
        null,
        callbackResponse
    );
};

export function getInvestmentNotes(page, params, allocatedCompleted) {
    return getRequest(
        'api/v1/portfolio/' + allocatedCompleted + '?page=' + page,
        params,
    );
};